import { useRealtime, type OnlineUser } from '../../hooks/useRealtime.tsx'
import { Avatar, userColorVar } from './Avatar.tsx'
import styles from './Presence.module.css'

/**
 * Avatars of whoever is online (ui-spec §6). Order is fixed by id so they never reshuffle, and
 * offline means absent from the stack — not greyed out.
 */
export function PresenceStack(): React.JSX.Element | null {
  const { online } = useRealtime()
  if (online.length === 0) return null

  return (
    // role="group" for the same reason as Avatar's role="img": aria-label on a plain <div> is
    // dropped, so this stack had a name nothing could read.
    <div className={styles.stack} role="group" aria-label="Osoby online">
      {online.map((user: OnlineUser) => (
        <span key={user.userId} className={styles.slot}>
          <Avatar
            name={user.name}
            colorVar={userColorVar(user.userId)}
            size={24}
            ring
            title={`${user.name} — online`}
          />
        </span>
      ))}
    </div>
  )
}

/**
 * Shown only while the socket is down. The interface must not pretend to be live when it is not
 * (PRD §4.4).
 */
export function ConnectionBadge(): React.JSX.Element | null {
  const { connection } = useRealtime()
  if (connection === 'live') return null

  return (
    <span className={styles.badge} role="status">
      <span className={styles.spinner} aria-hidden="true" />
      łączenie ponownie…
    </span>
  )
}
